import React, { useEffect, useState } from "react";
import "../Styles/Home.scss";
import giftGirl from "../../Assets/Images/TheGiftingLady.png";
import Search from "../SearchArea/Search.jsx";
import { useHistory } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { encodeSearchText } from "../../Utils/urlEncoder.js";
import { PillButton } from "../ui/Button/index";
import { categories, words } from "./data.js";
import useAuthStore from "../../Store/AuthStore.jsx";
import usePersonaStore from "../../Store/PersonaStore.jsx";
import PersonaSelector from "../Persona/PersonaSelector.jsx";

import { useTranslation } from "react-i18next";

const Body = () => {
  const { t } = useTranslation();
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  // Dynamic words translation
  const translatedWords = [
    t("homepage.words.mother"),
    t("homepage.words.father"),
    t("homepage.words.friend"),
    t("homepage.words.partner"),
    t("homepage.words.children"),
    t("homepage.words.teacher"),
    t("homepage.words.neighbor"),
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % translatedWords.length);
    }, 1500);
    return () => clearInterval(interval);
  }, [translatedWords.length]);


  const history = useHistory();
  const { isAuthenticated } = useAuthStore();
  const { selectedPersona, userPersonas } = usePersonaStore();

  const isFirstRender = React.useRef(true);

  useEffect(() => {
    // Skip the first render to prevent redirecting if a persona was already selected 
    // from a previous page before Home.jsx has a chance to clear it.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (selectedPersona) {
      // The search text is already updated in the store by setSelectedPersona
      // We just need to ensure we navigate to the search page
      if (history.location.pathname !== "/search") {
        history.push("/search" + window.location.search);
      }
    }
  }, [selectedPersona, history]);

  const handleAction = (categoryName) => {
    const key = categoryName.replace("#", "").toLowerCase().replace("-", "_");
    const nameKeyObj = categories.find(cat => cat.nameKey === key);
    const descriptionKey = nameKeyObj ? nameKeyObj.descriptionKey : `personalityTypes.desc${key.charAt(0).toUpperCase() + key.slice(1)}`;
    const translatedSentence = t(descriptionKey);

    // Wrap the translated sentence in the mention span format
    const mentionHtml = `<span data-type='mention' class='mention' data-id='1' data-label='${translatedSentence}'>${translatedSentence}</span>`;

    const encodedSearchText = encodeSearchText(mentionHtml);
    history.push(`/search?query=${encodedSearchText}`);
  };

  return (
    <div>
      <div className="relative">
        <div className="flex flex-col items-center px-40 py-36 gap-3 bg-red-400 rounded-t-none rounded-b-[20px] bg-blend-darken max-md:px-4">
          <img
            src={giftGirl}
            alt="Image"
            className="absolute top-0 right-[-20px] h-full w-auto object-fill z-0 md:object-cover hidden sm:block"
          />

          <div className=" max-w-[1100px] z-1">
            <div className="font-open-sans mb-8 w-full text-6xl font-bold tracking-wide text-center leading-[72px] text-grey-500 max-md:mt-10 max-md:max-w-full max-md:text-4.5xl max-md:leading-[60px]">
              {t("homepage.describeYour")}{' '}
              <span className=" transition-all">{translatedWords[currentWordIndex]}</span>
              {t("homepage.andDiscoverPerfect")} <span className="text-red-800">{t("homepage.perfect")}</span>{' '}
              {t("homepage.gift")}
            </div>
          </div>
          <div className="flex justify-center flex-wrap w-full z-1">
            {isAuthenticated && userPersonas.length > 0 && (
              <div className="w-11/12 mb-2 flex justify-start">
                <PersonaSelector hideCreate hideSuggested />
              </div>
            )}
            <AnimatePresence mode="wait">
              <Search pageType="home" />
            </AnimatePresence>
            <div className="flex gap-3 justify-center lg:flex-nowrap md:flex-wrap px-20 mt-12 w-full text-base font-bold leading-6 text-center whitespace-nowrap text-stone-50 max-md:flex-wrap max-md:px-5 max-md:mt-10 max-md:max-w-full">
              {categories.map((category) => (
                <PillButton
                  key={category.nameKey}
                  variant="customCategory"
                  size="sm"
                  onClick={() => handleAction('#' + category.nameKey)}
                  className={`shadow ${category.bgColor} text-stone-50`}
                >
                  {t(`personalityTypes.${category.nameKey}`)}
                </PillButton>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
